<template>
  <div v-if="showView" class="page-alert flex flex-center zindex-tip">
    <div class="page-body bg-white">
      <div class="page-header flex-row-align-center flex-row-justify-space-between">
        <p class="font-size-24 font-bold">纪事人物</p>
        <img class="cursor" src="../../../../../assets/icon-lib-close-blue.png" alt="" @click="showView = false">
      </div>
      <div class="page-options">
        <div class="page-options-region-person mach-width bg-white">
          <div class="flex-row-align-center page-options-region-person-pages">
            <p class="font-size-12 font-color-999 space">显示{{ total }}中的{{ range.start }}-{{ range.end }}条</p>
            <p class="font-size-12 font-color-264480 space cursor" :class="currentPage==1?'disabel':''" @click="prePage">上一页</p>
            <p class="font-size-12 font-color-264480 cursor" :class="currentPage==pages?'disabel':''" @click="nextPage">下一页</p>
          </div>
          <!-- <div class="page-options-region-person-items flex-row-align-center">
            <div class="position-relative item mach-height flex flex-center" data-sel="0" @click="personMenuSelect">
              <p class="font-color-264480 font-size-12 cursor">全部</p>
              <p v-if="personTopSelIndex==0" class="p-line bg-282B80 position-absolute" />
            </div>
            <div v-for="(letter,index) in personLetters" :key="letter" class="position-relative item mach-height flex flex-center" :data-sel="index+1" @click="personMenuSelect">
              <p class="font-color-264480 font-size-12 cursor">{{ letter }}</p>
              <p v-if="personTopSelIndex-1 == index" class="p-line bg-282B80 position-absolute" />
            </div>
          </div> -->
        </div>
      </div>

      <div v-if="reqParams.type == 'collection'" class="page-content bg-white">
        <div class="menu-content-item-list">
          <div v-for="(cate, index) in datas" :key="index" class="menu-content-item-list-item" @click="selectCate(cate)">
            <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="current.name == cate.personName?'sel':''">
              <p class="font-size-14">{{ cate.personName }}</p>
              <p class="font-size-14 font-color-999">{{ cate.total }}</p>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="page-content bg-white">
        <div class="menu-content-item-list">
          <div v-for="(cate, index) in datas" :key="index" class="menu-content-item-list-item" @click="selectCate(cate)">
            <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="current.name == cate.name?'sel':''">
              <p class="font-size-14">{{ cate.name }}</p>
              <p class="font-size-14 font-color-999">{{ cate.counrNumber }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="page-footer flex-center bg-white">
        <p class="bg-282B80 font-color-white flex-center font-size-14 radius-clip-5 btn cursor" @click="confirm">确定</p>
        <p class="bg-F3F4F9 font-color-264480 flex-center font-size-14 radius-clip-5 btn cursor" @click="closeView">关闭</p>
      </div>
    </div>
  </div>
</template>

<script>

import api from '../../../../../api/collections.js'

export default {
  data() {
    return {
      showView: false,
      personLetters: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
      personTopSelIndex: 0,

      reqParams: { type: 'collection', data: { size: 50, current: 1, searchKey: '' }},

      currentPage: 1,
      total: 0,
      pages: 0,
      range: { start: 0, end: 0 },
      datas: [],
      current: {
        name: '',
        data: ''
      }
    }
  },
  destroyed() {
    console.log('销毁')
  },
  methods: {
    show(data, searchType) {
      this.reqParams.type = searchType || 'collection'
      this.total = 0
      this.currentPage = 1
      this.range.start = 0
      this.range.end = 0
      this.pages = 0
      for (const key in data) {
        if (key === 'current' || key === 'size' || key === 'sortType') {
          continue
        } else {
          this.reqParams.data[key] = data[key]
        }
      }
      this.request()
      this.showView = true
    },
    request() {
      this.reqParams.data.current = this.currentPage
      const that = this
      this.reqParams.data.tenantId = this.$store.getters.tenantId
      api.personPage(this.reqParams).then(r => {
        that.total = r.data.total
        that.datas = r.data.records
        that.range.end = (that.currentPage - 1) * 50 + that.datas.length
        that.range.start = (that.currentPage - 1) * 50 + 1
        that.pages = r.data.pages
      })
    },
    personMenuSelect(v) {
      this.personTopSelIndex = v.currentTarget.dataset.sel
    },
    prePage() {
      if (this.currentPage > 1) {
        this.currentPage -= 1
        this.request()
      }
    },
    nextPage() {
      if (this.currentPage < this.pages) {
        this.currentPage += 1
        this.request()
      }
    },
    selectCate(v) {
      if (this.reqParams.type === 'collection') {
        if (this.current.name !== v.personName) {
          this.current.name = v.personName
          this.current.data = v
        }
      } else {
        if (this.current.name !== v.name) {
          this.current.name = v.name
          this.current.data = v
        }
      }
    },
    confirm() {
      this.showView = false
      this.$emit('select', { params: { personAffected: this.current.name }, display: this.current.name, type: 'personAffected' })
    },
    closeView() {
      this.total = 0
      this.currentPage = 1
      this.range.start = 0
      this.range.end = 0
      this.showView = false
      this.current.name = ''
      this.current.data = ''
    }
  }
}
</script>
<style src="@/styles/pc.css" scoped>
</style>
<style scoped>
  .page-alert {
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
  }

  .page-body {
    width: 500px;
  }

  .page-header {
    padding: 0 20px;
    height: 60px;
  }

  .page-options {
    border-bottom: 1px solid #eee;
  }

  .page-options-region-topic {
    height: 40px;
    padding: 0 20px;
  }

  .page-options-selection>div {
    padding: 0 6px;
    width: 40px;
    height: 40px;
  }

   .page-options-selection .line {
     height: 3px;
     width: 40px;
     bottom: 0;
   }

  .page-options-region-date{
    height: 40px;
    justify-content: end;
    padding: 0 16px;
  }

  .space {
    margin-right: 8px;
  }

  .page-content {
    height: 380px;
    overflow: scroll;
  }

  .page-footer {
    height: 60px;
  }

  .page-footer .btn {
    width: 100px;
    height: 30px;
    font-weight: 400;
    margin-right: 10px;
  }

  .page-footer .btn:last-child {
    margin: 0;
  }

  .page-options-region-person-pages {
    height: 24px;
    justify-content: end;
    padding: 0 20px;
  }

  .page-options-region-person-items {
    height: 24px;
    padding: 0 20px;
    margin-bottom: 10px;
  }

  .page-options-region-person-items .item {
    padding: 0 4px;
  }

  .page-options-region-person-items .item .p-line {
    left: 0;
    right: 0;
    bottom: -10px;
    height: 3px;
  }

  .menu-content-item-list-item-hg {
    height: 30px;
    padding: 0 10px;
  }

  .menu-content-item-list {
    padding: 10px;
  }
  .cate-sel-close {
    width: 30px;
    height: 30px;
  }

  .disabel {
    color: #999;
    cursor: not-allowed;
  }

  .sel {
   background-color: rgba(147, 150, 156, 0.4);
  }

  .sel p {
    color: #fff;
  }
</style>
